import React, { useCallback, useEffect } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import { PERMISSIONS, ROUTES } from '@/common';
import { useHistory } from '@/modules/core';
import { Access } from '@/modules/core/components';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import EmployeesList from '@/modules/employee/Employees/EmployeesList/EmployeesList';
import TopSection from '@/modules/employee/Employees/TopSection';
import { useAuthStore } from '@/modules/user/stores';
import theme from '@/styles/theme';
import { clearScrollRestoration } from '@/utils/hooks/useScrollRestoration';

const EmployeesPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.EMPLOYEES,
      title: 'Employees',
    },
  ]);

  useEffect(() => {
    clearScrollRestoration('/employee/');
  }, []);
  const { user } = useAuthStore();
  const history = useHistory();
  const goHome = useCallback(() => history.push(ROUTES.HOME), [history]);
  if (!user) {
    return (
      <Box width="100%" justify="center" align="center">
        <Preloader />
      </Box>
    );
  }

  return (
    <Access
      accessRequirements={[
        {
          permission: PERMISSIONS.VIEW_PROFILE,
        },
      ]}
      accessDeniedAction={goHome}
    >
      <Box width="100%" margin={{ top: '0' }} height="fit-content">
        <Topbar />
        <Box align="center" pad={{ bottom: 'spacing72' }}>
          <Box width={theme.defaultContentWidth}>
            <TopSection />
            <Box>
              <EmployeesList />
            </Box>
          </Box>
        </Box>
      </Box>
    </Access>
  );
};

export default EmployeesPage;
